import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import base64 from "base-64";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../utils/utilFunctions";

export const sendEmailVerification = createAsyncThunk(
  "auth/sendEmailVerification",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { email } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        username: email,
        accountType: "Organization",
      });
      const res = await axios.post("/auth/account/invite", body, config);
      successAlertHandle("Invitation Sent Successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const accountActivation = createAsyncThunk(
  "auth/accountActivation",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get(`/auth/account/activate?vendorUserId=${id}`);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const registerAccount = createAsyncThunk(
  "auth/registerAccount",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const {
        address,
        businessType,
        password,
        vendorUserId,
        email,
        phone,
        organization,
      } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        name: organization,
        primaryPhone: phone,
        email,
        vendorUserId,
        businessType,
        address,
        value: base64.encode(password),
      });
      const res = await axios.post(
        `/auth/org?vendorUserId=${vendorUserId}`,
        body,
        config
      );
      localStorage.setItem("vendorUserId", vendorUserId);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { username, password } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        type: "email",
        username,
        password: base64.encode(password),
      });
      const res = await axios.post(`/auth/account/login`, body, config);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get(`/api/account/logout`);
      localStorage.removeItem("vendorUserId");
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const forceResetPassword = createAsyncThunk(
  "auth/forceResetPassword",
  async ({ value, vendorUserId }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        value: base64.encode(value),
      });
      const res = await axios.post(
        `/auth/account/force-reset?vendorUserId=${vendorUserId}`,
        body,
        config
      );
      successAlertHandle("Password has been successfully reset!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ username }, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get(
        `/auth/account/reset-password?username=${username}`
      );
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const verifyNewPassword = createAsyncThunk(
  "auth/verifyNewPassword",
  async ({ value, recoveryCode, flowId }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        newPassword: base64.encode(value),
        recoveryCode,
      });
      const res = await axios.post(
        `/auth/account/verify-password?flowId=${flowId}`,
        body,
        config
      );
      successAlertHandle("Password has been successfully reset!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);
export const license = createAsyncThunk(
  "auth/license",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const license = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(license);
      const res = await axios.post(`/auth/account/license`, body, config);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);
